import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";

@Component({
  selector: "app-information-dialog",
  templateUrl: "./thx-dialog.component.html",
  styleUrls: ["./thx-dialog.component.scss"]
})
export class ThxDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<ThxDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {}
  closeAction() {
    this.dialogRef.close();
  }
}
